<div class="container">
	<nb-accordion class="accordion-card">
		<nb-accordion-item expanded>
			<nb-accordion-item-header>
				<h1 class="paragraph">DETEKTO MASHTRIMIN</h1>
			</nb-accordion-item-header>
			<nb-accordion-item-body>
				<div class="d-flex">
					<p class="short-paragraph">
						Në këtë uebfaqe, janë paraqitur skenaret e ndryshëm për zbulimin e
						mashtrimit në mënyrë që përdoruesi të ekzaminoj këto të dhëna.
						Ndikimi i inxhierisë, përzgjedhja e veçorive dhe nxjerrja e
						parametrave për hulumtim janë konsideruar me qëllim të arritjes së
						një performance parashikuese sa më të avancuar.
					</p>
					<img src="../../../../../assets/images/scenario.svg" />
				</div>
			</nb-accordion-item-body>
		</nb-accordion-item>
	</nb-accordion>

	<nb-card class="white-card mt-5">
		<p class="paragraph mb-4">Aksidentet e makinave të dëmtuara më parë</p>
		<p class="dark-paragraph">
			Me këtë lloj mashtrimi, dëmi ishte bërë para se të ndodhte aksidenti.
			<br />
			<br />

			Mashtrimi i tillë është i inskenuar të duket si një aksident. Zakonisht,
			ato aksidente përfshijnë një shofer që nuk dyshon, dhe ata pretendojnë se
			shoferi tjetër u shkaktoi të gjitha dëmtimet. <br />
			<br />

			Shpesh, dëmtimi i makinës ishte shkaktuar nga ata ose e njejta makinë
			ishte në një aksident tjetër të raportuar dhe të kompenzuar, por ajo kurrë
			nuk ishte rregulluar nga ana e individit. Në vend të kësaj, ata përdorin
			këtë makinë të dëmtuar për të bërë pretendime të rreme për përfitime
			shtesë. <br />
			<br />

			Për të kontrolluar nëse aksidenti i plotëson kriteret dhe është rast
			potencial për mashtrim shkruani numrin e targave të makinës apo numrin VIN
			të përfshirë në aksident dhe evidentoni historikun e aksidenteve te
			makinës.
		</p>
	</nb-card>
	<div class="search mb-4">
		<form
			class="form"
			#nameForm="ngForm"
			novalidate
			(ngSubmit)="saveNameForm(registrationPlatesVinNumber)"
		>
			<input
				[(ngModel)]="registrationPlatesVinNumber"
				name="platesVin"
				#platesVin="ngModel"
				placeholder="Kërko numrin e targave të makinës apo numrin VIN…"
				nbInput
			/>
			<button
				id="button"
				type="submit"
				class="blue-button ml-2"
				routerLink="/scenario-fourth-results/{{ registrationPlatesVinNumber }}"
				[disabled]="platesVin.invalid"
			>
				KËRKO
			</button>
		</form>
		<span
			id="button"
			class="text-danger ml-2 mt-4"
			*ngIf="platesVin && platesVin.invalid && platesVin.touched"
			>Ju lutem shkruani numrin VIN për të vazhduar</span
		>
	</div>
</div>
